import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/layouts/Default.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../components/layouts/Default.vue"),
  },
  {
    path: "*",
    name: "catchAll",
    component: Home,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
